<template>
  <div class="yxl-pop-up">
    <transition name="fade">
      <div
        class="night"
        v-show="show"
        @click="$emit('close')"
        @touchmove.prevent
      ></div>
    </transition>
    <transition :name="position">
      <div ref="pop" v-show="show" :class="position" class="slot-container">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'yxl-popup',
  props: {
    show: Boolean,
    position: {
      type: String,
      default: 'center' // bottom
    }
  },
  model: {
    prop: 'show',
    event: 'close'
  }
}
</script>

<style lang="scss" scoped>
@import 'animation';
.layer {
  position: fixed;
  z-index: 10;
}
.yxl-pop-up {
  position: absolute;
  top: 0;
  .night {
    @extend .layer;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .slot-container {
    @extend .layer;
  }
  .center {
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    transform-origin: 0 0;
  }
  .top {
    top: 0;
    left: 0;
  }
  .right {
    right: 0;
  }
  .bottom {
    bottom: 0;
    left: 0;
  }
  .left {
    left: 0;
  }
}
</style>
